export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-web-722ca9e9f86b469b9ab2619fb39f1643.svg";